import { QueryClient } from "@tanstack/react-query";
 
export const onError = (error: any) => {
  console.log("Error", error);
  if (error?.response) {
    if (error?.response?.data?.message) {
      // SnackbarHandler.errorToast(error?.response?.data?.message);
    }
    if (error?.response?.status === 401) {
 
    }
  } else {
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000,
    },
    mutations: {
      onError,
    },
  },
});
